import React, { useState } from 'react'

const DEFAULT_IFRAME_URL = 'https://www.ibet788.com'

const IFramePanel = () => {
      const [urlInput, setUrlInput] = useState(DEFAULT_IFRAME_URL)
      const [iframeSrc, setIframeSrc] = useState(DEFAULT_IFRAME_URL)
      const [iframeError, setIframeError] = useState('')

    return (
        <>
            <form
                className="rounded-2xl border border-customAccent/40 bg-white p-2 shadow-sm dark:border-customMuted/30 dark:bg-customSurface text-customBlack"
                onSubmit={(event) => {
                    event.preventDefault()
                    const trimmed = urlInput.trim()
                    if (!trimmed) {
                        setIframeError('Enter a full URL to preview.')
                        return
                    }
                    try {
                        const nextUrl = new URL(trimmed.includes('://') ? trimmed : `https://${trimmed}`)
                        setIframeSrc(nextUrl.toString())
                        setIframeError('')
                    } catch (error) {
                        setIframeError('Enter a valid URL (https://example.com)')
                    }
                }}
            >
                {/* <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-customSecondaryText dark:text-customHeading">
                    Preview a site
                </label> */}
                <div className="flex flex-col gap-2 sm:flex-row">
                    <input
                        type="text"
                        value={urlInput}
                        onChange={(event) => setUrlInput(event.target.value)}
                        className="w-full rounded-xl border border-customSurfaceMuted px-3 py-2 text-sm text-customBlack shadow-inner focus:border-customAccent focus:outline-none focus:ring-2 focus:ring-customAccent/40 dark:border-customSurface dark:bg-customSurfaceMuted dark:text-white"
                        placeholder="https://example.com"
                    />
                    <button
                        type="submit"
                        className="inline-flex items-center justify-center gap-2 rounded-xl bg-customAccentBlue px-4 py-2 text-sm font-semibold text-white transition hover:bg-customAccentBlue/90 focus:outline-none focus:ring-2 focus:ring-customAccent/40 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                        Show
                    </button>
                </div>
                {iframeError ? (
                    <p className="mt-2 text-xs text-customOrange">{iframeError}</p>
                ) : (
                    <>
                        {/* <p className="mt-2 text-xs text-customSecondaryText dark:text-customHeading">
                            URLs are auto-prefixed with https:// when missing.
                        </p> */}
                        <p className="mt-1 text-xs font-medium text-customAccentBlue">
                            Currently showing: {iframeSrc}
                        </p>
                    </>
                )}
            </form>
            <div className="mt-1 min-h-[550px] overflow-hidden rounded-2xl border border-customAccent/30 bg-white shadow-inner dark:border-customSurfaceMuted dark:bg-customSurface">
                <iframe
                    src={iframeSrc}
                    title="External preview"
                    className="min-h-[550px] w-full rounded-2xl"
                    loading="lazy"
                    sandbox="allow-same-origin allow-forms allow-scripts allow-popups"
                    referrerPolicy="no-referrer"
                />
            </div>
        </>
    )
}

export default IFramePanel;
